(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-fan-card"] && !Shopify.designMode) return;
  try {
    customElements.get('card-fan-carousel-component') ||
    customElements.define(
      'card-fan-carousel-component',
      class extends HTMLElement {
        connectedCallback() {
          this.stage = this.querySelector('.card-fan__stage');
          this.cards = Array.from(this.querySelectorAll('.card-fan__card'));
          this.n = this.cards.length;
          this.active = 0;
          this.lock = false;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.duration = parseFloat(getComputedStyle(this).getPropertyValue('--fan-duration')) || 450;

          this.cards.forEach((card, i) => this.apply(card, this.offsetOf(i)));

          this.cards.forEach((card) => {
            card.addEventListener('click', (event) => {
              if (event.target.closest('a')) return;
              if (this.swiped) {
                this.swiped = false;
                return;
              }
              this.cancelAutoplay();
              this.bringToFront(card);
            });
            card.addEventListener('keydown', (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();
              this.cancelAutoplay();
              this.bringToFront(card);
            });
          });

          this.addEventListener('pointerdown', (event) => {
            this.startX = event.clientX;
            this.startY = event.clientY;
          });
          this.addEventListener('pointerup', (event) => {
            const dx = event.clientX - this.startX;
            const dy = event.clientY - this.startY;
            this.swiped = Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy);
            if (!this.swiped) return;
            this.cancelAutoplay();
            clearTimeout(this.chainTimer);
            this.step(dx < 0 ? 1 : -1);
          });

          const swipes = parseInt(this.dataset.autoplaySwipes, 10) || 0;
          if (swipes > 0 && !this.reduced && this.n > 1) this.observeAutoplay(swipes);
        }

        disconnectedCallback() {
          this.cancelAutoplay();
          clearTimeout(this.chainTimer);
        }

        bringToFront(card) {
          clearTimeout(this.chainTimer);
          const offset = this.offsetOf(this.cards.indexOf(card));
          if (offset === 0) return;
          const direction = Math.sign(offset);
          let remaining = Math.abs(offset);
          const run = () => {
            this.step(direction);
            remaining -= 1;
            if (remaining > 0) this.chainTimer = setTimeout(run, this.duration + 40);
          };
          run();
        }

        cancelAutoplay() {
          clearTimeout(this.autoplayTimer);
          this.autoplayCancelled = true;
        }

        observeAutoplay(count) {
          const repeat = this.dataset.autoplayMode !== 'once';
          const io = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) {
                this.inView = false;
                return;
              }
              if (this.inView) return;
              this.inView = true;
              if (!repeat && this.autoplayCancelled) return;
              this.runAutoplay(count);
              if (!repeat) io.disconnect();
            },
            { threshold: 0.45 }
          );
          io.observe(this);
        }

        runAutoplay(count) {
          clearTimeout(this.autoplayTimer);
          this.autoplayCancelled = false;
          let done = 0;
          const tick = () => {
            if (this.autoplayCancelled) return;
            this.step(1);
            done += 1;
            if (done < count) this.autoplayTimer = setTimeout(tick, this.duration + 180);
          };
          this.autoplayTimer = setTimeout(tick, 250);
        }

        offsetOf(index) {
          let rel = (index - this.active + this.n) % this.n;
          if (rel > this.n / 2) rel -= this.n;
          return rel;
        }

        apply(card, offset) {
          card.style.setProperty('--o', offset);
          card.style.zIndex = String(this.n - Math.round(Math.abs(offset)));
          card.classList.toggle('is-front', offset === 0);
        }

        step(direction) {
          if (this.lock || this.n < 2) return;

          const offsets = this.cards.map((_, i) => this.offsetOf(i));
          const edgeOffset = direction > 0 ? Math.min(...offsets) : Math.max(...offsets);
          const wrapIndex = offsets.indexOf(edgeOffset);
          const wrapCard = this.cards[wrapIndex];

          this.active = (this.active + direction + this.n) % this.n;

          if (this.reduced) {
            this.cards.forEach((card, i) => this.apply(card, this.offsetOf(i)));
            return;
          }

          this.lock = true;

          const ghost = wrapCard.cloneNode(true);
          ghost.removeAttribute('role');
          ghost.removeAttribute('tabindex');
          ghost.setAttribute('aria-hidden', 'true');
          ghost.classList.add('card-fan__card--swap');
          ghost.style.pointerEvents = 'none';
          ghost.style.zIndex = '0';
          this.stage.appendChild(ghost);

          wrapCard.classList.add('card-fan__card--swap');
          wrapCard.style.transition = 'none';
          this.apply(wrapCard, this.offsetOf(wrapIndex));
          wrapCard.style.setProperty('--s', '0.7');
          wrapCard.style.opacity = '0';
          void wrapCard.offsetWidth;
          wrapCard.style.transition = '';
          wrapCard.style.setProperty('--s', '1');
          wrapCard.style.opacity = '';

          ghost.style.setProperty('--s', '0.7');
          ghost.style.opacity = '0';
          setTimeout(() => ghost.remove(), this.duration + 250);

          this.cards.forEach((card, i) => {
            if (card !== wrapCard) this.apply(card, this.offsetOf(i));
          });

          setTimeout(() => {
            wrapCard.classList.remove('card-fan__card--swap');
            this.lock = false;
          }, this.duration);
        }
      }
    );
  } catch(e) { console.error(e); }
})();

})();
